<nav>
    <ul class="navbar-nav mr-auto" *ngIf="tree">
        <li
            *ngFor="let item of menu"
        >
            <a *ngIf="!item.submenu.length && !this.regExternalLink.test(item.url); else extItemLink" class="nav-link" routerLink="{{item.url}}">{{item.title}}</a>
            <ng-template #extItemLink>
                <a
                    *ngIf="this.regExternalLink.test(item.url)"
                          class="nav-link"
                          href="{{item.url}}"
                >{{item.title}}</a>
            </ng-template>
            <a *ngIf="item.submenu.length" class="nav-link" >{{item.title}}</a>
            <div *ngIf="item.submenu.length" class="dropdown-menu">
                <div *ngFor="let subitem of item.submenu" class="dropdown-item" [class.arrow]="subitem.submenu.length">
                    <a class="nav-link"
                            *ngIf="!this.regExternalLink.test(subitem.url); else extLink"
                            routerLink="{{subitem.url}}"
                        >{{subitem.title}}
                    </a>
                    <ng-template #extLink>
                        <a
                            *ngIf="this.regExternalLink.test(subitem.url)"
                            class="nav-link"
                            href="{{subitem.url}}"
                        >{{subitem.title}}</a>
                    </ng-template>
                    <div *ngIf="subitem.submenu.length" class="dropdown-menu">
                        <div *ngFor="let subitem2 of subitem.submenu" class="dropdown-item">
                            <a *ngIf="!this.regExternalLink.test(subitem2.url); else extLink2"
                                class="nav-link"
                                routerLink="{{subitem2.url}}"
                            >{{subitem2.title}}</a>
                            <ng-template #extLink2 >
                                <a *ngIf="this.regExternalLink.test(subitem2.url)"
                                    class="nav-link"
                                    href="{{subitem2.url}}"
                                >{{subitem2.title}}</a>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</nav>



// WEBPACK FOOTER //
// ./src/app/layouts/menu/menu.template.html